<template>
  <div class="d-flex py-2 rounded gap">
    <div class="d-flex flex-column justify-center">
      <div>
        <div class="rounded-circle pa-2"
          :class="[mainStore.module.status == 'ouverte' ? 'bg-dark-green' : 'bg-dark-red']">
          <v-icon v-if="mainStore.module.status == 'ouverte'" icon="mdi-pencil-outline" color="grey_1"
            size="large"></v-icon>
          <v-icon v-else icon="mdi-pencil-off-outline" color="grey_1" size="large"></v-icon>
        </div>
      </div>
    </div>
    <div>
      <div class="text-body-1 font-weight-bold">
        <div v-if="mainStore.billetterie_mode || mainStore.parcours_billetterie_mode">
          <div v-if="mainStore.module.status == 'ouverte'">Billetterie ouverte</div>
          <div v-else>Billetterie fermée</div>
        </div>
        <div v-else>
          <div v-if="mainStore.module.status == 'ouverte'">Inscription ouverte</div>
          <div v-if="mainStore.module.status == 'avant_ouverture'">Ouverture des inscriptions</div>
          <div v-if="mainStore.module.status == 'apres_fermeture'">Inscriptions closes</div>
        </div>

        <div class="text-body-2">
          <div v-if="mainStore.module.status == 'ouverte'">Fermeture le {{
            $moment(mainStore.module.date_fin_inscription).format("D MMMM YYYY") }} à {{
              mainStore.module.heure_fin_inscription }}</div>
          <div v-if="mainStore.module.status == 'avant_ouverture'">le {{
            $moment(mainStore.module.date_debut_inscription).format("D MMMM YYYY") }} à {{
              mainStore.module.heure_debut_inscription }}</div>

          <div v-if="mainStore.module.status == 'apres_fermeture'">Depuis le {{
            $moment(mainStore.module.date_fin_inscription).format("D MMMM YYYY") }} à {{
              mainStore.module.heure_fin_inscription }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useMainStore } from '@/stores/mainStore';
import { mapStores } from 'pinia';
export default {
  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapStores(useMainStore),
  },
  methods: {},
};
</script>

<style lang="scss" scoped></style>